/* eslint no-use-before-define: 0  */
import img1 from '../images/box-item/card-item8.jpg'
import imga1 from '../images/avatar/avt-11.jpg'
import img2 from '../images/box-item/image-box-10.jpg'
import imga2 from '../images/avatar/avt-12.jpg'
import img3 from '../images/box-item/card-item-11.jpg'
import imga3 from '../images/avatar/avt-13.jpg'
import img4 from '../images/box-item/image-box-1.jpg'
import imga4 from '../images/avatar/avt-14.jpg'
import imgCollection1 from '../images/avatar/avt-18.jpg'
import imgCollection2 from '../images/avatar/avt-16.jpg'
import imgCollection3 from '../images/avatar/avt-17.jpg'


const todayPickData = [
    {
        id: 1,
        img: img1,
        title: "★ Karambit | Doppler",
        tags: "Minimal Wear",
        imgAuthor: imga1,
        nameAuthor: "Tyler Covington",
        price: "100,000 VNĐ",
        item_float: "0.07874",
        discount: 30,
        phase: "Phase 1"
    },
    {
        id: 2,
        img: img2,
        title: "AWP | Dragon Lore",
        tags: "Minimal Wear",
        imgAuthor: imga2,
        nameAuthor: "Freddie Carpeter",
        price: "900,000 VNĐ",
        item_float: "0.19734",
        discount: 50,
        phase: "Phase 2"
    },
    {
        id: 3,
        img: img3,
        title: "AWP | Gungnir",
        tags: "Factory New",
        imgAuthor: imga3,
        nameAuthor: "Tyler Covington",
        price: "8,100,000 VNĐ",
        item_float: "0.141234",
        discount: 20,
        phase: "Ruby"
    },
    {
        id: 4,
        img: img4,
        title: "★ Sport Gloves | Pandora's Box",
        tags: "Field-Tested",
        imgAuthor: imga4,
        nameAuthor: "Tyler Covington",
        price: "18,500,000 VNĐ",
        item_float: "0.005678",
        discount: 24,
        phase: "Sapphire"
    },
    {
        id: 1,
        img: img1,
        title: "★ Karambit | Doppler",
        tags: "Minimal Wear",
        imgAuthor: imga1,
        nameAuthor: "Tyler Covington",
        price: "100,000 VNĐ",
        item_float: "0.07874",
        discount: 30,
        phase: "Phase 1"
    },
    {
        id: 2,
        img: img2,
        title: "AWP | Dragon Lore",
        tags: "Minimal Wear",
        imgAuthor: imga2,
        nameAuthor: "Freddie Carpeter",
        price: "900,000 VNĐ",
        item_float: "0.19734",
        discount: 50,
        phase: "Phase 2"
    },
    {
        id: 3,
        img: img3,
        title: "AWP | Gungnir",
        tags: "Factory New",
        imgAuthor: imga3,
        nameAuthor: "Tyler Covington",
        price: "8,100,000 VNĐ",
        item_float: "0.141234",
        discount: 20,
        phase: "Ruby"
    },
    {
        id: 4,
        img: img4,
        title: "★ Sport Gloves | Pandora's Box",
        tags: "Field-Tested",
        imgAuthor: imga4,
        nameAuthor: "Tyler Covington",
        price: "18,500,000 VNĐ",
        item_float: "0.005678",
        discount: 24,
        phase: "Sapphire"
    },
    {
        id: 1,
        img: img1,
        title: "★ Karambit | Doppler",
        tags: "Minimal Wear",
        imgAuthor: imga1,
        nameAuthor: "Tyler Covington",
        price: "100,000 VNĐ",
        item_float: "0.07874",
        discount: 30,
        phase: "Phase 1"
    },
    {
        id: 2,
        img: img2,
        title: "AWP | Dragon Lore",
        tags: "Minimal Wear",
        imgAuthor: imga2,
        nameAuthor: "Freddie Carpeter",
        price: "900,000 VNĐ",
        item_float: "0.19734",
        discount: 50,
        phase: "Phase 2"
    },
    {
        id: 3,
        img: img3,
        title: "AWP | Gungnir",
        tags: "Factory New",
        imgAuthor: imga3,
        nameAuthor: "Tyler Covington",
        price: "8,100,000 VNĐ",
        item_float: "0.141234",
        discount: 20,
        phase: "Ruby"
    },
    {
        id: 4,
        img: img4,
        title: "★ Sport Gloves | Pandora's Box",
        tags: "Field-Tested",
        imgAuthor: imga4,
        nameAuthor: "Tyler Covington",
        price: "18,500,000 VNĐ",
        item_float: "0.005678",
        discount: 24,
        phase: "Sapphire"
    },
]

export default todayPickData;
